import React from 'react';
import * as WashCareIcons from 'Shared/Icons/WashCareIcons';

export function WashIcon({ name }: { name: string }) {
  switch (name) {
    case '30Cdelic':
    case '30Chand':
    case '30Cnorm':
    case '30Cperm':
    case '30Cwool':
    case '40Cdelic':
    case '40Chand':
    case '40Cnorm':
    case '40Cperm':
    case '60Cnorm':
    case '60Cperm':
    case '95Cnorm':
    case '95Cperm':
      return <WashCareIcons.IconTempWash />;
    case 'Dripdry':
      return <WashCareIcons.IconDripdry />;
    case 'Dryclpetr':
      return <WashCareIcons.IconDryclpetr />;
    case 'Dryflat':
      return <WashCareIcons.IconDryflat />;
    case 'Handwash':
      return <WashCareIcons.IconHandwash />;
    case 'IronH':
      return <WashCareIcons.IconIronH />;
    case 'IronL':
      return <WashCareIcons.IconIronL />;
    case 'IronM':
      return <WashCareIcons.IconIronM />;
    case 'Linedry':
      return <WashCareIcons.IconLinedry />;
    case 'Nobleach':
      return <WashCareIcons.IconNobleach />;
    case 'Nodrycl':
      return <WashCareIcons.IconNodrycl />;
    case 'NoDryclean':
      return <WashCareIcons.IconNodrycl />;
    case 'NoIron':
      return <WashCareIcons.IconNoIron />;
    case 'Notumble':
      return <WashCareIcons.IconNotumble />;
    case 'Nowash':
      return <WashCareIcons.IconNowash />;
    case 'TumbleH':
      return <WashCareIcons.IconTumbleH />;
    case 'TumbleL':
      return <WashCareIcons.IconTumbleL />;
    case 'TumbleM':
      return <WashCareIcons.IconTumbleM />;
    default:
      return null;
  }
}